import Leaflet from 'leaflet';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import {
  AttributionControl,
  MapContainer,
  TileLayer,
  ZoomControl,
} from 'react-leaflet';
import { useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';

import { version } from '../../../../package.json';
import { TABLET_MAX_WIDTH, ZINDEX } from '../../constants';
import { useGame } from '../../context';
import { LatLngType } from '../../types';
import MarkersLayer from '../markers-layer';
import MapBoundsDebugger from './map-bounds-debugger';
import MapURLParams from './map-url-params';

const LeafletMapComponent = React.memo(({ onCreated, params }) => {
  const { map, title } = useGame();
  const isTablet = useMediaQuery({ maxWidth: TABLET_MAX_WIDTH });

  const lastCenter = useSelector(
    _ => _.lastCenter,
    // NOTE update une seule fois
    // on ne veut pas que la methode `displayMap` soit
    // appellée a chaque fois que le last center se change
    () => true
  );

  const displayMap = useMemo(
    () => (
      <MapContainer
        scrollWheelZoom
        attributionControl={false}
        bounceAtZoomLimits={false}
        center={
          params?.latlng || (lastCenter?.length && lastCenter) || map.center
        }
        className="smart-maps-leaflet"
        crs={Leaflet.CRS.Simple}
        doubleClickZoom={false}
        maxBounds={map.maxBounds}
        maxZoom={map.zoom.max}
        minZoom={map.zoom.min}
        whenCreated={onCreated}
        zoom={params?.zoom || map.zoom.current}
        zoomControl={false}>
        <TileLayer
          errorTileUrl="/tiles/blank.png"
          tileSize={256}
          url={map.tiles}
        />
        <AttributionControl
          position="bottomleft"
          prefix={`Smart Maps | ${title} v${version}`}
        />
        {!isTablet && <ZoomControl position="topright" />}
        {!map?.maxBounds?.length && <MapBoundsDebugger />}
        <MarkersLayer />
        <MapURLParams />
      </MapContainer>
    ),
    [isTablet, params, onCreated, title, lastCenter, map]
  );

  // console.log('render map');

  return (
    <div className="is-overlay" style={{ zIndex: ZINDEX.MAP }}>
      {displayMap}
    </div>
  );
});

LeafletMapComponent.defaultProps = {
  params: null,
};

LeafletMapComponent.propTypes = {
  onCreated: PropTypes.func.isRequired,
  params: PropTypes.shape({
    latlng: LatLngType,
    zoom: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),
};

LeafletMapComponent.displayName = 'LeafletMapComponent';

export default LeafletMapComponent;
